<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentcolor">
    <path
      d="M16.04 6.02h-1.11v-2c0-1.09-.88-1.96-1.95-1.96h-1.8c-1.07 0-1.94.87-1.94 1.95v2.01H9.1a.98.98 0 0 0-.98.98v8.11c0 .53.43.98.98.98h.14v4.02c0 1.08.87 1.95 1.95 1.95h1.79c1.07 0 1.95-.87 1.95-1.95v-4.02h.14c.53 0 .97-.44.97-.98v-5.06c1.11 0 2.01-.9 2.01-2 0-1.11-.9-2.02-2-2.02ZM11.2 3.95l1.84.06v2.01h-1.87l.02-2.07Zm1.84 16.15s-.02.06-.06.06l-1.84-.06v-4.02h1.9v4.02Z"
    />
  </svg>
</template>

<script>
export default {};
</script>
